import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "services/baseQuery";
import {
  UserCreateProps,
  UserDeleteInviteProps,
  UserInvitedInfoProps,
  UserResendInviteProps,
  UserSendInviteProps,
  UserUpdateProps,
} from "type/users";

export const user = createApi({
  reducerPath: "user",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    sendInvite: builder.mutation<any, UserSendInviteProps>({
      query: (body) => ({
        url: `user/invite`,
        method: "POST",
        body,
      }),
    }),

    invitedUser: builder.mutation<any, UserInvitedInfoProps>({
      query: (body) => ({
        url: `user/invited/verification`,
        method: "POST",
        body,
      }),
    }),
    deleteUser: builder.mutation<any, { id: string }>({
      query: ({ id }) => ({
        url: `user/${id}/delete`,
        method: "POST",
      }),
    }),
    resendInvite: builder.mutation<any, UserResendInviteProps>({
      query: (body) => ({
        url: `user/invite-resend`,
        method: "POST",
        body,
      }),
    }),
    createUser: builder.mutation<any, UserCreateProps>({
      query: (body) => ({
        url: `user/invited/register`,
        method: "POST",
        body,
      }),
    }),
    updateUser: builder.mutation<any, UserUpdateProps>({
      query: (body) => ({
        url: `update-users`,
        method: "PUT",
        body,
      }),
    }),
    deleteInvite: builder.mutation<any, UserDeleteInviteProps>({
      query: (body) => ({
        url: `user/invite-delete`,
        method: "DELETE",
        body,
      }),
    }),
  }),
});

export const {
  useSendInviteMutation,
  useInvitedUserMutation,
  useDeleteUserMutation,
  useResendInviteMutation,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteInviteMutation,
} = user;
